import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-tool',
  templateUrl: './admin-tool.component.html',
  styleUrls: ['./admin-tool.component.css']
})
export class AdminToolComponent implements OnInit {

  ngOnInit(): void {
  }

}
